// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterLinks_root__k14D0","title":"FooterLinks_title__G9817","link":"FooterLinks_link__57juF"};